import { z } from 'zod';

export const DESIGN_MESSAGE_MAX = 2000;

export const sendDesignSchema = z.object({
  mediaId: z.string().min(1, { error: 'orders:design.validation.mediaRequired' }),
  message: z
    .string()
    .trim()
    .max(DESIGN_MESSAGE_MAX, { error: 'orders:design.validation.messageLength' }),
});

export type SendDesignFormInput = z.input<typeof sendDesignSchema>;
export type SendDesignFormOutput = z.output<typeof sendDesignSchema>;
